import { store } from 'redux/store';
import { useCallback, useEffect, useState } from 'react';
import { getHoldingClasses } from '../redux/holdingClassActions';

type UseGetHoldingClassesProps = {
  societyId?: string;
  page?: number;
  rowsPerPage?: number;
};

export const useGetHoldingClasses = ({
  societyId,
  page = 1,
  rowsPerPage = 10,
}: UseGetHoldingClassesProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchHoldingClasses = useCallback(
    async (controller: AbortController) => {
      if (!societyId) return;

      try {
        setIsLoading(true);

        await store.dispatch(
          getHoldingClasses({
            societyId,
            params: {
              page,
              items: rowsPerPage,
              fieldsToPopulate: ['numerationOption'],
            },
            includeRanges: true,
            signal: controller.signal,
          })
        );

        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      } catch (error) {
        if (!controller.signal.aborted) {
          setIsLoading(false);
          setIsError(true);
        }
      }
    },
    [page, rowsPerPage, societyId]
  );

  useEffect(() => {
    const controller = new AbortController();

    fetchHoldingClasses(controller);

    return () => controller.abort();
  }, [fetchHoldingClasses]);

  return { isLoading, isError };
};
